module.exports = __webpack_public_path__ + "static/img/R2_s2026_Logo_Color_Dates_WebRes_Medium.505fff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2026/R2_s2026_Logo_Color_Dates_WebRes_Medium.png
// module id = AZWa
// module chunks = 1